<div class="d-flex flex-row">
  <div
    class="card p-0 mr-2 w-100"
    style="max-height: calc(100vh - 200px); overflow-y: auto"
  >
    <table class="field-config-table">
      <thead>
        <tr>
          <th>Field</th>
          <th>
            Visible<br />
            <input type="checkbox" name="allVisible"
              [(ngModel)]="srcTable.allVisible" (change)="srcTable.allColumnCheckboxChange($event)"
            />
          </th>
          <th>
          </th>
          <th>Filter Value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let config of fieldConfigs">
          <td class="text-right">
            {{ config.column.title }}
          </td>
          <td>
            <input type="checkbox" [(ngModel)]="config.column.visible" (change)="srcTable.columnStateChanged(config.column)"/>
          </td>
          <ng-container *ngIf="config.column.filterEditFn">
            <td>
                <button class="w-100 btn btn-sm btn-secondary" (click)="srcTable.editCustomFilter(config.column,config.filter)">
                  Edit
                </button>
            </td>
            <td>
              <fes-table-view-filter-input
                *ngIf="config.filter" [filter]="config.filter"
                (keyUp)="filterKeyUp$.next($event)">
              </fes-table-view-filter-input>
            </td>
          </ng-container>
          <ng-container *ngIf="!config.column.filterEditFn">
            <td>
              <select *ngIf="config.filter"
                [(ngModel)]="config.filter.mode" (ngModelChange)="onFilterModeChanged(config.column)">
                <option *ngFor="let mode of srcTable.filterModes">{{ mode }}</option>
              </select>
            </td>
            <td>
              <fes-table-view-filter-input
                *ngIf="config.filter&&(config.filter.mode!='empty'&&config.filter.mode!='not empty')" [filter]="config.filter"
                (keyUp)="filterKeyUp$.next($event)">
              </fes-table-view-filter-input>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
    <ul class="mt-2 alert alert-warning">
      <li>
        Most percentage fields use internal format "#.###" (min 0.000, max 1.000).  I.E. for >= 50, try >= 0.50
      </li>
      <li>
        Some fields may default to "TEXT" instead of "NUMERIC" which impacts filters: = >= <=
      </li>
    </ul>
  </div>
  <div class="d-flex flex-column justify-content-start">
    <div class="card mb-2">
      <div *ngIf="pagingEnabled" class="d-flex flex-row p-1">
        <span class="text-muted font-italic">Page Size:&nbsp;</span>
        <select [disabled]="srcTable.isLoading" name="dateDropdown" #dateDropdown
          [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let pageSizeOption of srcTable.pageSizeOptions" [ngValue]="pageSizeOption">
            {{ !pageSizeOption ? "All" : pageSizeOption }}
          </option>
        </select>
      </div>
    </div>
    <div class="card mb-2 px-1">
      <div class="form-check">
        <label class="form-check-label" *ngIf="srcTable.bulkRowActions?.length">
          <input type="checkbox" class="form-check-input"
            name="bShowBulkActionsColumn"
            [(ngModel)]="srcTable.bShowBulkActionsColumn">
          Show Bulk Action Column
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <input type="checkbox" class="form-check-input"
            name="bShowHeader"
            [(ngModel)]="srcTable.bShowHeader">
          Show Header
        </label>
      </div>
    </div>
  </div>
</div>
